<template>
  <div id="app" v-bind:class="{ dark: darkmode }">
    <app-header :compact="true"></app-header>
    <div class="focus">
      <div class="wrap">
        <div class="card">
          HEWWO
          <div class="inputs">
            <input type="text" placeholder="Password" v-model="password"/>
            <button class="large blue" v-on:click="auth">Authenticate</button>
            <div>{{message}}</div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '../common/Header'
import AppFooter from '../common/Footer'
import router from '../../router';
export default {
  components: {
    AppHeader, AppFooter
  },
  data: () => {
    return {
      password: "",
      message: ""
    }
  },
  computed: {
    darkmode() {
      return this.$store.state.darkmode
    },
  },
  methods: {
    auth() {
      this.$store.dispatch('authenticate', this.password).then((res) => {
        if(this.$store.state.api_token) {
          router.push('/admin') // successful login
        }
      }, (err) => {
        console.warn(err)
      })
    }
  }
}
</script>
